import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums, MANUAL_DESCRIPTION,PERSONAL_DELIVERY} from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';

const getValue = require('lodash/get');

@Injectable()
export class AlmaRequestOther extends AbstractRequest{

    constructor(
        private mappingTablesCache: MappingTablesCache,
        private configurationUtil:ConfigurationUtil) {
        super();
        this.formFields = [
            {
                key: 'hold-or-booking',
                name: 'requestType',
                label: 'almaRequest.requestType',
                value: 'hold',
                path: 'groups-list-map/requestType',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,

                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                },
                options:[
                    {
                        label:'almaRequest.requestType.hold',
                        value:'hold'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },{
                key: MANUAL_DESCRIPTION,
                name: MANUAL_DESCRIPTION,
                mandatoryGroup:MANUAL_DESCRIPTION,
                label: 'almaRequest.manualDescription',
                saveFormField:null,
                tooltip:'',
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },{
                key: 'pickupInstitutionFulNet',
                name: 'pickupInstitutionFulNet',
                path: 'ful-net-request-other-groups-list-map/pickupInstitutionFulNet',
                label: 'almaRequest.pickupInstitution',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpInstitution',
                filterSearchAriaLabel: 'nui.aria.lookUpInstitution',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupLocationFulNet']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'pickupLocationFulNet',
                name: 'pickupLocationFulNet',
                path: 'ful-net-request-other-groups-list-map/pickupLocationFulNet',
                label: 'almaRequest.pickupLocation',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpLocation',
                filterSearchAriaLabel: 'nui.aria.lookUpLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupInstitutionFulNet']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: {key : 'requestType', value: ['booking','hold']}
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                path: 'pickupLocation',
                label: 'almaRequest.pickupLocation',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpLocation',
                filterSearchAriaLabel: 'nui.aria.lookUpLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'addressLine1',
                name: 'addressLine1',
                label: 'almaRequest.addressLine1',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine2',
                name: 'addressLine2',
                label: 'almaRequest.addressLine2',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine3',
                name: 'addressLine3',
                label: 'almaRequest.addressLine3',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine4',
                name: 'addressLine4',
                label: 'almaRequest.addressLine4',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'city',
                name: 'city',
                label: 'almaRequest.city',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'stateProvince',
                name: 'stateProvince',
                label: 'almaRequest.stateProvince',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'postalCode',
                name: 'postalCode',
                label: 'almaRequest.postalCode',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'notNeedAfter',
                name: 'lastInterestDate',
                label: 'almaRequest.notNeedAfter',
                existingPath: 'hasHold',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                minDate: 'now',
                dependOn: {key : 'requestType', value: 'hold'},
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaRequest.comment',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },{
                key: 'instCode',
                name: 'instCode',
                label: 'almaRequest.institutionCode',
                mandatory: true,
                valuePath: 'instCode',
                existingPath: 'instCode',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                label: 'almaRequest.pickupLocation',
                mandatory: false,
                valuePath: 'pickupLocation',
                existingPath: 'pickupLocation',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'callNumber',
                name: 'callNumber',
                label: 'almaRequestOther.callNumber',
                mandatory: true,
                valuePath: 'callNumber',
                existingPath: 'callNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },{
                key: 'holdingKey',
                name: 'holdingKey',
                label: 'almaRequestOther.holdingKey',
                mandatory: true,
                valuePath: 'holdingKey',
                existingPath: 'holdingKey',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },
            {
                key: 'chapterArticleTitle',
                name: 'chapterArticleTitle',
                label: 'almaRequest.chapterArticleTitle',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'chapterArticleTitle',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'chapterArticleAuthor',
                name: 'chapterArticleAuthor',
                label: 'almaRequest.chapterArticleAuthor',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'chapterArticleAuthor',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'startPage',
                name: 'startPage',
                label: 'almaRequest.startPage',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'startPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'endPage',
                name: 'endPage',
                label: 'almaRequest.endPage',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'endPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'volume',
                name: 'volume',
                label: 'almaRequest.volume',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'volume',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'issue',
                name: 'issue',
                label: 'almaRequest.issue',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'issue',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'part',
                name: 'part',
                label: 'almaRequest.part',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'part',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'publicationDate',
                name: 'publicationDate',
                label: 'almaRequest.publicationDate',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'publicationDate',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaRequest.genericCheckBox',
                        value:'N'
                    }
                ]
            }
        ];
    }

    protected personalDeliveryDependency(field, formFields, formData, data): void {
        field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
        let row = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS, {source2: field.key, target: 'Yes'});
        if(row.length == 0){
            return;
        }
        let isFulNet = (formData.pickupLocationFulNet && formData.pickupLocationFulNet != null && formData.pickupLocationFulNet != "" );
        if(! isFulNet && (formData.pickupLocation == null || formData.pickupLocation == "" )){
            return;
        }
        let val:string[] = isFulNet ? formData.pickupLocationFulNet.split("$$") : formData.pickupLocation.split("$$");
        if(val != null && val.length ==2){
            let type :string = val[1];
            if(type && (type.startsWith("USER_HOME_ADDRESS") || type.startsWith("USER_WORK_ADDRESS") || type.startsWith("P_DELIV_ADDRESS"))){
                field.uiType = FormBuilderEnums.UI_TYPE.TEXT;
                field.mandatory = (row[0]['source5'] === 'true');
                if(isFulNet){
                    for(let groupList of data[0]["ful-net-request-other-groups-list-map"]){
                        let groupListRow = groupList.pickupLocationFulNet;
                        if(groupListRow == null || groupListRow == ''){
                            continue;
                        }
                        let pickupLocRow = groupListRow.filter( e1 => {return e1.key === formData.pickupLocationFulNet});
                        if(pickupLocRow == null || pickupLocRow == ''){
                            continue;
                        }
                        this.updateFormData(formData, field, getValue(pickupLocRow[0],field.key));
                        break;
                    }
                }else{
                    let pickupLocRow = data[0].pickupLocation.filter( e1 => {return e1.key === formData.pickupLocation});
                    if(pickupLocRow == null || pickupLocRow == ''){
                        return;
                    }
                    this.updateFormData(formData, field, getValue(pickupLocRow[0],field.key));
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/AlmaRequestOther.ts